import React, { ChangeEvent, FormEvent, ReactElement, useState } from "react";
import { Button, Form } from "react-bootstrap";

import { RouteComponentProps } from "react-router";

import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";

import { ProjectBudget } from "./ProjectBudget";
import { ProjectBudgetService } from "./ProjectBudgetService";

interface IParams {
	id?: string;
}

export const CreateProjectBudgetPage = (
	props: RouteComponentProps<IParams>,
): ReactElement => {
	const [submitDisabled, setSubmitDisabled] = useState(true);
	const projectBudgetService = new ProjectBudgetService();
	const [budget] = useState(new ProjectBudget());

	document.title = "Create a new budget";

	budget.accountId = parseInt(props.match.params.id || "", 10);

	const handleSubmit = (event: FormEvent): void => {
		event.preventDefault();

		projectBudgetService.create!(budget)
			.then(newProj => {
				toast.success(`"${newProj.name}" project created`);
				props.history.push(`/project-budget/${newProj.id}`);
			})
			.catch(error => {
				toast.error(error.message);
			});
	};

	return (
		<div className="container" id="create-project">
			<h1 className="mb-4">Create Budget</h1>
			<Form onSubmit={handleSubmit}>
				<Form.Group>
					<Form.Label>Budget Name</Form.Label>
					<Form.Control
						type="text"
						onChange={(event: ChangeEvent<HTMLInputElement>) => {
							budget.name = event.target.value;
							if (budget.name.length > 1) {
								setSubmitDisabled(false);
							} else {
								setSubmitDisabled(true);
							}
						}}
					/>
				</Form.Group>
				<Form.Group>
					<Form.Label>Budget Amount</Form.Label>
					<Form.Control
						type="text"
						onChange={(event: ChangeEvent<HTMLInputElement>) => {
							budget.amount = parseInt(event.target.value, 10);
						}}
					/>
				</Form.Group>
				<Form.Group>
					<Form.Label>Notes</Form.Label>
					<Form.Control
						as="textarea"
						rows={3}
						onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
							budget.notes = event.target.value;
						}}
					/>
				</Form.Group>

				<Button
					disabled={submitDisabled}
					variant="primary"
					type="submit"
					className="mt-5"
				>
					Submit
				</Button>
			</Form>
		</div>
	);
};
